import React from "react";
import { MessageCircle } from "lucide-react";

const WA_NUMBER = "3547883999";

export default function WhatsAppPush({ className = "" }) {
  const msg = encodeURIComponent("Hi 👋\nThanks for your request.\n\nPlease send:\n• Pickup location\n• Drop-off location\n• Date & time\n• Number of passengers\n\nI'll confirm the price immediately 👍");
  return (
    <a
      href={`https://wa.me/${WA_NUMBER}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-push"
      className={`group relative flex items-center gap-4 rounded-xl border border-emerald-200 bg-emerald-50/60 px-5 py-4 sm:px-6 sm:py-5 hover:bg-emerald-50 transition-colors ${className}`}
    >
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#25D366] text-white shrink-0">
        <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true">
          <path d="M17.5 14.4c-.3-.1-1.7-.9-2-1s-.5-.1-.7.1-.8 1-.9 1.2c-.2.2-.3.2-.6.1-1.8-.9-3-1.6-4.2-3.7-.3-.5.3-.5.9-1.6.1-.2.1-.4 0-.6s-.7-1.7-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1.1 1.1-1.1 2.7s1.1 3.1 1.3 3.4c.2.2 2.3 3.5 5.5 4.9.8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.6-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.4 1.3 4.8L2 22l5.3-1.4c1.3.7 2.9 1.1 4.7 1.1 5.5 0 10-4.5 10-10S17.5 2 12 2z" />
        </svg>
      </span>
      <div className="flex-1 min-w-0">
        <p className="font-heading text-base sm:text-lg font-semibold text-slate-900">
          Need a quick answer? Message us on WhatsApp — we reply fast.
        </p>
        <p className="text-xs text-slate-600 mt-0.5 flex items-center gap-1">
          <MessageCircle size={12} /> +{WA_NUMBER} · typical reply within minutes during the day
        </p>
      </div>
      <span className="hidden sm:inline-flex items-center rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white group-hover:bg-slate-800">
        Chat now
      </span>
    </a>
  );
}
